import React from "react";
import { ToastContainer } from "react-toastify";
import useEagerConnect from "../../hooks/useEagerConnect";
import SEO from "../SEO/SEO";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

const Layout = ({ title, siteMetadata, framework, submenu, children }) => {
  useEagerConnect();

  return (
    <div className={framework ? "page-root framework" : "page-root"}>
      <SEO title={title} siteMetadata={siteMetadata} />

      <Header submenu={submenu} />

      <div className="background"></div>

      {children}

      <Footer />

      <ToastContainer theme="dark" />
    </div>
  );
};

export default Layout;
